import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "../assets/logo-prodrive.svg";
import { useTransporterInfo } from "../hooks/useTransporterInfo";
import { SubscriptionType } from "../interfaces/transporters.interface";
import { AuthService } from "../service/AuthService";
import { useCookies } from "react-cookie";

const getSidebarItems = (subscriptionType?: SubscriptionType) => [
  { to: "/drivers", icon: "ph-bold ph-users", text: "Gestion des chauffeurs" },
  { to: "/chapters", icon: "ph-bold ph-book-open", text: "Gestion des chapitres" },
  { to: "/faq", icon: "ph-bold ph-info", text: "FAQ" },
  {
    to: "/referral-stats",
    icon: "ph-bold ph-handshake",
    text: "Programme de Parrainage",
  },
  ...(subscriptionType !== SubscriptionType.PAID
    ? [{ to: "/subscription", icon: "ph-bold ph-star", text: "Passer Premium" }]
    : []),
  { to: "/parameters", icon: "ph-bold ph-gear", text: "Parameters" },
];

const Sidebar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { transporterInfo } = useTransporterInfo();
  const history = useHistory();
  const [, , removeCookie] = useCookies(["Authorization"]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const authService = new AuthService();
  const onClickLogout = () => {
    authService
      .logOut()
      .then((data) => {
        localStorage.clear();
        history.push("/");
      })
      .catch((err) => {
        console.log(err);
        localStorage.clear();
        removeCookie("Authorization");
        history.push("/");
      });
  };

  const sidebarItems = getSidebarItems(transporterInfo.subscriptionType);

  return (
    <>
      {/* Toggle button for small screens */}
      <button
        className="lg:hidden fixed top-4 left-4 z-20 p-2 bg-transparent rounded-md"
        onClick={toggleSidebar}
      >
        <i className={`pi ${isOpen ? "pi-times" : "pi-bars"} text-xl`}></i>
      </button>

      {/* Overlay for small screens when sidebar is open */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={toggleSidebar}
        ></div>
      )}

      {/* Sidebar */}
      <div
        className={`bg-white text-gray-800 h-screen flex flex-col fixed left-0 top-0 z-40 transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 lg:static`}
      >
        <div className="h-20 flex justify-center items-center py-5">
          <img src={logo} alt="Logo Pro Driver" className="h-full" />
        </div>
        <nav className="flex-grow pt-3 text-md whitespace-nowrap">
          <ul>
            {sidebarItems.map((item, index) => (
              <li key={index} className="border-b border-gray-200">
                <Link
                  to={item.to}
                  className="flex items-center py-4 px-8 hover:text-secondary hover:translate-x-2 transition duration-300 ease-in-out"
                  onClick={() => setIsOpen(false)}
                >
                  <i className={`${item.icon} mr-4 text-xl`}></i>
                  {item.text}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="mt-auto pb-4">
          <span
            className="flex items-center py-4 px-6 cursor-pointer hover:text-secondary hover:translate-x-2 transition duration-300 ease-in-out"
            onClick={onClickLogout}
          >
            <i className="ph-bold ph-sign-out mr-4 text-xl"></i>
            Deconnexion
          </span>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
